import { colors } from 'theme'

import Box from '@mui/material/Box'

import { PageCard } from './PageCard'
import { PageContent } from './PageContent'
import { PageFooter } from './PageFooter'
import { PageHeader } from './PageHeader'
import { PageTitle } from './PageTitle'

export type PageProps = {
  children: React.ReactNode
}

export const Page = ({ children }: PageProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr)', // Lets the page shrink below its content's width
        gridTemplateRows: 'auto 1fr auto',
        background: colors.backgroundGrey,
      }}
    >
      {children}
    </Box>
  )
}

Page.Header = PageHeader
Page.Content = PageContent
Page.Footer = PageFooter
Page.Title = PageTitle
Page.Card = PageCard
